import { render, staticRenderFns } from "./DownloadIconButton.vue?vue&type=template&id=315368a3&scoped=true&"
import script from "./DownloadIconButton.vue?vue&type=script&lang=js&"
export * from "./DownloadIconButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadIconButton.vue?vue&type=style&index=0&id=315368a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315368a3",
  null
  
)

export default component.exports